export default __webpack_public_path__ + "static/media/best-price.c3710973.svg";